function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-favorite-1{fill:#fff;}.cls-favorite-2{fill:#f2f2f2;}.cls-favorite-3{fill:#dadada;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-favorite-1",
  d: "M0,5A5,5,0,0,1,5,0H140a5,5,0,0,1,5,5V183a5,5,0,0,1-5,5H5a5,5,0,0,1-5-5Z"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-favorite-2",
  x: 69.68,
  y: 22.31,
  width: 57.28,
  height: 37.4
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-favorite-3",
  x: 17.5,
  y: 48.65,
  width: 37.03,
  height: 11.06
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-favorite-3",
  x: 17.5,
  y: 22.53,
  width: 37.03,
  height: 11.06
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-favorite-3",
  x: 17.5,
  y: 74.78,
  width: 109.46,
  height: 11.06
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-favorite-3",
  x: 17.5,
  y: 100.9,
  width: 109.46,
  height: 11.06
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-favorite-3",
  x: 17.5,
  y: 127.03,
  width: 109.46,
  height: 11.06
});

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-favorite-3",
  x: 17.5,
  y: 153.15,
  width: 109.46,
  height: 11.06
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "cls-favorite-3",
  d: "M72,59.68,86.91,44.75,93.14,51l11.14-11.14,19.87,19.87S72,59.64,72,59.68Z"
});

var _ref12 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-favorite-3",
  cx: 81.27,
  cy: 33.24,
  r: 4.97
});

function SvgFavorite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 145 188",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavorite);
export default __webpack_public_path__ + "static/media/favorite.4f7e5092.svg";
export { ForwardRef as ReactComponent };